import {fromJS} from 'immutable';
import userActions from '../actions/user.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    loading: false,
    accountInfo: {},
    checkingVerification: false
});

export const userReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case userActions.TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION: {
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['verificationSent'], () => true);
            return newState;
        }
        case userActions.TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION_SUCCESS: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(
                ['accountInfo', 'twoFactorAuthentication', 'enabled'],
                () => true
            );
            return newState;
        }
        case userActions.TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case userActions.TYPES.CHECK_EMAIL_VERIFICATION: {
            newState = newState.updateIn(['checkingVerification'], () => true);
            return newState;
        }
        case userActions.TYPES.CHECK_EMAIL_VERIFICATION_SUCCESS: {
            newState = newState.updateIn(['checkingVerification'], () => false);
            newState = newState.updateIn(
                ['accountInfo', 'emailVerified'],
                () => action.payload.data.emailVerified
            );
            return newState;
        }
        case userActions.TYPES.CHECK_EMAIL_VERIFICATION_FAILED: {
            newState = newState.updateIn(['checkingVerification'], () => false);
            return newState;
        }
        case userActions.TYPES.LOGOUT: {
            const accountInfo = {
                isLoggedIn: false
            };
            newState = newState.updateIn(['accountInfo'], () => accountInfo);
            return newState;
        }
        default:
            return state;
    }
};

export default dieselReducer('user', userReducer);
